import { render, staticRenderFns } from "./createSimpleBModel.vue?vue&type=template&id=1e4a20e0&scoped=true"
import script from "./createSimpleBModel.vue?vue&type=script&lang=js"
export * from "./createSimpleBModel.vue?vue&type=script&lang=js"
import style0 from "./createSimpleBModel.vue?vue&type=style&index=0&id=1e4a20e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4a20e0",
  null
  
)

export default component.exports